import { Box, InputLabel, Typography } from "@mui/material";
import { Editor } from "components/Editor";

interface Props {
  commentary: string;
}

export default function ReportCommentary({ commentary }: Props) {
  return (
    <>
      <InputLabel>
        <Typography fontWeight={700}>Commentary:</Typography>
      </InputLabel>
      <Editor value={commentary} hideToolbar readOnly hideEditor />
    </>
  );
}
